var loadjs_umdExports = {};
var loadjs_umd = {
  get exports(){ return loadjs_umdExports; },
  set exports(v){ loadjs_umdExports = v; },
};

export { loadjs_umd as __module, loadjs_umdExports as exports };
